import { FMatQuadrantGraphNode, FMatQuadrantRenderer, FMatQuadrantTriangleNode } from "@dino/shared"
import React, { useMemo } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useDinoPaperQuery, useEcodeByPaperQuery } from "../../../generated-types"
import { ResultLayout } from "./ResultLayout"
import { useTranslation } from "react-i18next"
import { FMatDesc } from "./FMatDesc"
import { Box, Button, Heading } from "grommet"
import DiagLayout from "../../../components/DiagLayout"

export default () => {
  const { paperId } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data } = useDinoPaperQuery({ variables: { paperId } })
  const { data: paper } = useEcodeByPaperQuery({ variables: { paperId: Number(paperId) } })

  const value = useMemo(() => {
    const newValue = []
    if (data) {
      const { results } = data.dinoPaper
      newValue.push(results[0])
      newValue.push(results[1])
      newValue.push(results[2])
      newValue.push(results[3])
    }
    return newValue
  }, [data, paper])

  if (paper && !paper.ecodeByPaper.isLeader) {
    return (
      <DiagLayout>
        <Box align="center" justify="center" pad={{ top: "xlarge", bottom: "medium" }} gap="medium" fill="horizontal">
          <Heading level={3} textAlign="center" style={{ whiteSpace: "pre-wrap" }}>
            {t("FMAT_BSI360.result-message")}
          </Heading>
          <Button
            primary
            color="#C02026"
            label={t("button.confirm")}
            onClick={() => navigate("/my")}
          />
        </Box>
      </DiagLayout>
    )
  }

  return (
    <ResultLayout extraContent={<FMatDesc pgmId={data?.dinoPaper?.item?.id} value={value} />}>
      {({ width, refStage }) => (
        <FMatQuadrantRenderer width={width} ref={refStage}>
          {value.length >= 4 && <FMatQuadrantGraphNode value={value} />}
          {value.length === 6 && <FMatQuadrantTriangleNode value={value} />}
        </FMatQuadrantRenderer>
      )}
    </ResultLayout>
  )
}
